/** Imported Pricebook descriptions may contain HTML. Render complete text, never executable markup. */
export function pricebookDescription(value: string | null | undefined) {
 if(!value)return '';
 const doc=new DOMParser().parseFromString(value.replace(/<br\s*\/?\s*>|<\/(?:p|div|li|h[1-6])>/gi,'\n'),'text/html');
 doc.querySelectorAll('script,style').forEach(node=>node.remove());
 return (doc.body.textContent??'').trim();
}
export function RenewalAgreementDetails({agreement}:{agreement?:{name:string;description?:string|null}|null}) {
 if(!agreement?.description)return null;
 return <section aria-label="Membership agreement"><h3 className="font-semibold text-[var(--brand-navy)]">{agreement.name}</h3><p className="mt-2 whitespace-pre-wrap text-sm text-[var(--ink-soft)]">{pricebookDescription(agreement.description)}</p></section>;
}
